module.exports = __webpack_public_path__ + "static/media/info.362bc358.svg";